import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {WHITE} from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';

export interface BaseStatusButtonProps {
  buttonStyle: ButtonStyle;
  icon?: JSX.Element;
  isDropdown: boolean;
  menuOptions?: Array<JSX.Element>;
  onClick?: () => void;
  text: string;
  disabled?: boolean;
  className?: string;
}

export default function BaseStatusButton({
  buttonStyle,
  icon,
  isDropdown,
  menuOptions,
  onClick,
  text,
  disabled,
  className,
}: BaseStatusButtonProps): JSX.Element {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const buttonComponent = (
    <Button
      className={className}
      disabled={disabled}
      buttonStyle={buttonStyle}
      icon={icon}
      isDropdown={isDropdown}
      onClick={onClick}
      text={text}
      size={ButtonSize.MEDIUM}
      dataTestAttrs={{component: 'BaseStatusButton', element: 'button'}}
    />
  );

  if (menuOptions == null) {
    return buttonComponent;
  }
  return (
    <Dropdown
      {...getTestProps({component: 'BaseStatusButton', element: 'dropdown'})}
      menu={getDropdownMenu(menuOptions)}
      isOpen={isDropdownOpen}
      onToggle={setIsDropdownOpen}
      closeOnOutsideClick={true}
      closeOnInsideClick={true}
    >
      {buttonComponent}
    </Dropdown>
  );
}

function getDropdownMenu(menuOptions: Array<JSX.Element>): JSX.Element {
  return (
    <Menu
      className={css(styles.dropdown)}
      {...getTestProps({component: 'BaseStatusButton', element: 'dropdownContent'})}
    >
      {menuOptions}
    </Menu>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    backgroundColor: WHITE,
    borderRadius: 4,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    marginTop: 2,
    padding: 14,
    position: 'absolute',
    minWidth: 200,
    top: '100%',
    left: 'auto',
    right: 0,
    margin: 'auto',
  },
});
